import React from 'react';
import Homepage from '../components/Homepage';

export default function Home() {
	return <Homepage />;
}
